import { categoryStore, reviewStore } from '@/store';
import { rankingMixin } from './ranking';
import { facebookMixin } from './facebook';
import { routeMixin } from './route';

import { helper } from '@/mixins/helper';
export const reviewMixin = {
    data() {
        return {
            review: [],
            reviews: [],
            info: [],
            categoryState: categoryStore.state,
            reviewState: reviewStore.state,
            loaded: false,
        };
    },
    mixins: [rankingMixin, facebookMixin, routeMixin, helper],
    async created() {
        if (Boolean(this.useAsHomePage) || Boolean(this.isMainPartner)) {
            return;
        }

        if (!this.categoryState.rankingList) {
            await this.getCategory();
        }
        await this.getReviewByRoute();
    },
    watch: {
        $route() {
            if (this.$route.name === 'review') {
                return this.getReview();
            }
        },
    },
    updated() {
        this.indexCtaBtn();
    },
    methods: {
        indexCtaBtn() {
            let elClass = document.getElementsByClassName(
                'visit-dating-site-button'
            );

            Array.from(elClass).forEach((item, index) => {
                item.setAttribute('data-index', index);
            });
        },
        eventTracking(event) {
            if (event?.target?.className.includes('visit-dating-site-button')) {
                this.clickoutEvent(Number(event.target.dataset['index']));
            }
        },
        clickoutEvent(position) {
            this.clickout(
                this.categoryState.category.name,
                this.partner.clicked_partner_name,
                position,
                'review'
            );
        },
        getReviewByRoute() {
            if (this.$route.name === 'partner-review') {
                return this.getReviewByPosition();
            }

            if (this.$route.name === 'review') {
                return this.getReview();
            }
        },
        getReview(reviewSlug = null) {
            const url = this.getReviewUrl(reviewSlug);
            window.axios.get(url).then((response) => {
                if (!response.data.review) {
                    this.$router.push({
                        path: '/',
                    });
                }

                // @todo testing psi score without external style sheet
                if (
                    this.$globalConstants['host']['name'] === 'datingsider.no'
                ) {
                    response.data.review['is_content_creator_styling'] = false;
                }

                this.loadArticleEditorStyleSheet(response.data.review);
                this.review = this.updateImageUrls(response.data.review);

                this.handleReviewContentPlaceHolders();

                document.title = this.review.title;
                if (response.data.review.canonical) {
                    document.getElementById('canonical').href =
                        response.data.review.canonical;
                }
                if (response.data.review.json_ld) {
                    document.getElementById('jsonLD').text =
                        response.data.review.json_ld;
                }

                // if (response.data.partner == null) {
                //     this.$router.push({ path: '/' });
                //     return;
                // }

                if (this.categoryState.rankingList.length > 0) {
                    const rankingPartner =
                        this.categoryState.rankingList.filter((obj) => {
                            return obj['review_slug'] === this.review['slug'];
                        });

                    if (rankingPartner.length === 1) {
                        this.reviewState.reviewPartner = Object.assign(
                            response.data.partner,
                            rankingPartner[0]
                        );
                        this.loaded = true;
                        return;
                    }
                }

                this.reviewState.reviewPartner = response.data.partner;
                this.loaded = true;
            });
        },
        handleReviewContentPlaceHolders() {
            let portalPartnerRowPlaceholder = `[partner-row]`;
            const placeholderPartnerRowCount = this.review['content'].split(
                portalPartnerRowPlaceholder
            ).length;

            for (let i = 1; i <= placeholderPartnerRowCount; i++) {
                let tag = `<div id="partner-row-${i}"></div>`;
                this.review['content'] = this.review['content'].replace(
                    portalPartnerRowPlaceholder,
                    tag
                );
            }

            this.portalPartnerRowCount = placeholderPartnerRowCount - 1;

            // conditions to handle dynamic partner placeholder
            let portalPartnerRowWithLogoPlaceholder = `[partner-with-logo]`;

            const placeholderCount = this.review['content'].split(
                portalPartnerRowWithLogoPlaceholder
            ).length;

            for (let i = 1; i <= placeholderCount; i++) {
                let tag = `<div id="partner-with-logo-${i}"></div>`;
                this.review['content'] = this.review['content'].replace(
                    portalPartnerRowWithLogoPlaceholder,
                    tag
                );
            }

            this.portalPartnerWithLogoCount = placeholderCount - 1;

            this.categoryState.isLoaded = true;
        },
        getReviewUrl(reviewSlug = null) {
            if (!reviewSlug) {
                reviewSlug = this.$route.params.id;
            }
            return `/host/${this.$globalConstants.host['id']}/review-slug/${reviewSlug}`;
        },
        getPartnerBySlug(slug) {
            if (this.categoryState.rankingList) {
                return this.categoryState.rankingList.find((s) => {
                    return s.review_slug === slug;
                });
            }
        },
        getReviewByPosition() {
            if (this.categoryState.rankingList) {
                const position = this.$route.params.position - 1;

                if (this.categoryState.rankingList[position] === 'undefined') {
                    this.$router.push({
                        path: '/',
                    });
                    return;
                }
                this.reviewState.reviewPartner =
                    this.categoryState.rankingList[position];
                if (this.partner.review_slug) {
                    window.axios
                        .get(
                            `/host/${this.$globalConstants.host['id']}/review-slug/${this.partner.review_slug}`
                        )
                        .then((response) => {
                            this.review = response.data.review;
                            document.title = this.review.title;
                            this.loaded = true;
                        });
                } else {
                    this.$router.push({
                        path: '/',
                    });
                }
            }
        },
        getReviews() {
            window.axios
                .get(`/host/${this.$globalConstants.host['id']}/reviews`)
                .then((response) => {
                    this.reviews = response.data.reviews;
                });
        },
        partnerScore(partner) {
            let score = partner?.score;
            if (!score) {
                return '0.0';
            }
            if (score.toString().length < 2) {
                score = score + '.0';
            }
            return score.toString();
        },
    },
    computed: {
        partner() {
            return this.reviewState.reviewPartner;
        },
    },
};
